import React from "react";

import Button from "components/Button";
import DevicePreview from "components/DevicePreview";
import { StyledForm } from "./styledComponents";
import { ChannelFileField } from "./components";

const EnterpriseThemeForm = ({
  onSubmit,
  submitting,
  pristine,
  logoImage,
  overlayImage,
  backgroundColor,
  galleryColor,
  bgColorChanged,
  overlayChanged,
  edit,
  openColorPickerModal,
}) => {
  const { control } = form;

  return (
    <StyledForm onSubmit={form.handleSubmit(handleSubmit)}>
      <div className="channel-forms__theme-form-wrapper">
        <DevicePreview
          logoImage={logoImage}
          overlayImage={bgColorChanged ? null : overlayImage}
          backgroundColor={overlayChanged ? null : backgroundColor}
        />
        <div className="channel-forms__theme-fields">
          <Controller
            control={control}
            name="big_logo_image"
            render={({ field: { ref, ...fieldRest } }) => (
              <ChannelFileField
                name="big_logo_image"
                type="file"
                label="Logo"
                iconOffset="-110px"
                height={168}
                info="
                    Appears on the iPad start screen and in the online gallery header.
                  "
                instructions="Instructions: .png up to 1300px wide by 800px tall"
                buttonText="Upload Logo"
                field={fieldRest}
                {...fieldRest}
              />
            )}
          />
          <Controller
            control={control}
            name="background"
            render={({ field: { ref, ...fieldRest } }) => (
              <ChannelFileField
                name="background"
                type="file"
                label="App Background"
                iconOffset="-134px"
                height={251}
                info="
                    Appears behind your logo and app controls, and in front of a live
                    camera-view background.
                  "
                instructions="Instructions: .png exactly 1536px wide by 2048px tall"
                buttonText="Upload Background"
                secondButtonProps={{
                  buttonText: backgroundColor || "#424242",
                  onClick: openColorPickerModal,
                  backgroundColor,
                }}
                field={fieldRest}
                {...fieldRest}
              />
            )}
          />
          <Controller
            control={control}
            name="gallery_color"
            render={({ field: { ref, ...fieldRest } }) => (
              <ChannelFileField
                name="gallery_color"
                label="Gallery Background"
                iconOffset="-80px"
                height={123}
                info="Appears in the online gallery behind your logo and photos."
                secondButtonProps={{
                  buttonText: galleryColor || backgroundColor || "#424242",
                  onClick: openColorPickerModal,
                  backgroundColor,
                }}
                field={fieldRest}
                {...fieldRest}
              />
            )}
          />
        </div>
      </div>
      <div className="channel-forms__group">
        {edit ? (
          <Button type="submit" disabled={submitting || pristine}>
            Save
          </Button>
        ) : (
          <Button type="submit" disabled={submitting || pristine}>
            Save and Next
          </Button>
        )}
      </div>
    </StyledForm>
  );
};

export default EnterpriseThemeForm;
